module.exports = dibs_admin_layout_internal;